{
  "de": {
    "todo_v2": {
      "actions": {
        "confirm": "Als erledigt markieren",
        "create": "Aufgabe",
        "reopen": "Erneut öffnen",
        "update": "Aufgabe bearbeiten"
      },
      "assignee_types": {
        "customer": "Kunde",
        "employee": "Mitarbeiter",
        "partner": "Partner"
      },
      "attributes": {
        "assignees": "Verantwortliche",
        "created_at": "Erstellt",
        "due_date": "Frist",
        "project": "Projekt",
        "status": "Status",
        "todo_group": "Aufgabe",
        "unit": "Einheit"
      },
      "labels": {
        "add_assignee": "Verantwortliche Person hinzufügen …",
        "add_customers": "Kunden hinzufügen",
        "completed": "Erledigt",
        "confirm_message": "Möchten Sie diese Aufgabe wirklich als erledigt markieren?",
        "customers": "Kunden",
        "group_already_added": "Diese Aufgabe wurde dieser Einheit bereits hinzugefügt.",
        "my_todos": "Meine Aufgaben",
        "no_assignees": "Noch keine Verantwortlichen.",
        "no_todos": "Noch keine Aufgaben.",
        "no_todos_group": "Noch keine Aufgaben in dieser Gruppe.",
        "no_todos_unit": "Noch keine Aufgaben für diese Einheit.",
        "publish_all": "Alle veröffentlichen",
        "publish_customers": "Für die Kunden jeder Einheit veröffentlichen",
        "published": "Veröffentlicht",
        "required": "Dieses Feld ist erforderlich",
        "select_group": "Aufgabe auswählen",
        "upload_hint": "Laden Sie die angeforderten Dokumente hoch, um diese Aufgabe zu erledigen.",
        "uploaded_documents": "Hochgeladene Dokumente"
      },
      "statuses": {
        "completed": "Erledigt",
        "draft": "Entwurf",
        "pending": "Ausstehend"
      },
      "toasts": {
        "completed": "Aufgabe erledigt",
        "create": "Aufgabe erstellt",
        "delete": "Aufgabe gelöscht",
        "uncompleted": "Aufgabe wieder geöffnet",
        "update": "Aufgabe aktualisiert"
      }
    }
  }
}
